import {LaundryOperationModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: LaundryOperationModel = {
  id: '',
  companiaId: '',
  clienteId: '',
  siteId: '',
  campamentoId: '',
  tipoRecepcion: '',
  tipoAdministracion: '',
  flagEnvioComprobante: false,
  puntoId: '',
  email: '',
  responsable: '',
  telefono: '',
  servicioId: '',
  colaboradorId: '',
  colaborador: '',
  nroBoleta: '',
  estado: '',
  empresa: '',
  proveedorId: '',
  proveedor: '',
  ...aditionalValues,
}
